<template>
  <div style="height: 100%" class="clearfix homePage">
    <div class="home-contant">
      <div class="home-left1">
		  <Split v-model="splitLeft" mode="vertical" @on-move-end="splitLeftChange">
			  <template #top>
				  <div class="demo-split-pane">
					 <div class="home-left1-top area-item">
					   <div class="area-item-title flex">
						   <div class="area-item-left-box">
							   <div class="area-item-title-text">
							   {{ $I18N("个人信息") }}							   							
							   </div>
							   <div class="scan-contant-tip" @click="generateQRCode">							     
								 <Tooltip :content="lang == 'zh-Hans' ? showMyCode.chs : showMyCode.en" placement="right">
								    <img src="../../images/scan.png" />
								 </Tooltip>
							   </div>
						   </div>
					   
						
					     <div class="mine-contant-tip" :title="$I18N('InformationWrong')" @click="showTips = true">
							 
					       <img src="../../images/help.png" />
					     </div>
					   </div>
					   <div class="name">{{ $I18N("欢迎您") }} {{ userInfo.namedd }}</div>
					   <div>{{ $I18N("部门") }}：{{ org.namedd }}</div>
					   <div>{{ $I18N("科室") }}：{{ department.namedd }}</div>
					   <div>{{ $I18N("岗位") }}：{{ userInfo.postdd }}</div>
					   <div>{{ $I18N("手机号") }}：{{ userInfo.phoneNumber }}</div>
					   <div>{{ $I18N("短号") }}：{{ userInfo.cornet }}</div>
					   <div>{{ $I18N("邮箱") }}：{{ userInfo.emailAddress }}</div>
					 </div>
				  </div>
			  </template>
			  <template #bottom>
				  <div class="demo-split-pane">
					  <div class="home-left1-bottom area-item">
					    <div v-if="!isCanBook" class="area-item-title">
					      <div class="area-item-title-text">{{ $I18N("Contacts") }}</div>
					    </div>
					    <div class="home-left1-bottom-txl" :class="showDownloadAPPQR ? 'txlH1' : 'txlH2'">
					      <div v-if="!isCanBook" class="txl-top-serch-contant">
					        <treeselect :options="orgDate" :placeholder="$I18N('Select')" :noChildrenText="$I18N('无')"
					          class="tree-data-contant" @input="changeTreeId" :clearable="true" v-model="treeId"></treeselect>
					        <!-- <icon type="ios-search" class="txl-top-serch-search" @click="changeShowSearch" /> -->
							<!-- <div class="txl-top-serch-search"></div> -->
					        <div class="txl-top-serch-check">
					          <input id="showW" type="checkbox" :checked="isShowWB" @change="changeShowWB" />
					          <label for="showW" style="white-space: nowrap;">{{ $I18N("显示外部人员") }}</label>
					        </div>
					      </div>
					      <Input v-if="!isCanBook" type="text" v-model="txlInputValue"
					         @on-enter="txlInputChange" />
					  
					      <div v-if="!isCanBook" class="txl-user-contant">
					        <div v-for="(user, index) in txlUserList" :id="user.id">
					          <div class="txl-user-item" @click="toggle(index, user)">
					            <!-- <img class="txl-user-img" :src="user.headImgUrl"  @error="onImageError" /> -->
					            <img class="txl-user-img" src="../../images/renyuan.png" />
					            <div class="txl-user-name">
					              <p>{{ lang == "zh-Hans" ? user.name : user.eName }}</p>
					              <p>{{ lang == "zh-Hans" ? user.chPost : user.enPost }}</p>
					            </div>
					            <img class="txl-user-img-down" src="../../images/close.png" />
					          </div>
					          <div v-if="user.isShowInfo" class="txl-user-item-info">
					            <Tabs v-model="tab">
					              <Tab-pane :label="$I18N('BasicInfo')" name="tab1">
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("JobNumber")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.emplCode
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Gender")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.gender
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("PhoneNumber")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.showPhone == "1"
					                      ? ""
					                      : txlUserInfo.phoneNumber
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Cornet")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.cornet
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("EmailAddress")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.emailAddress
					                  }}</span>
					                </div>
					              </Tab-pane>
					              <Tab-pane :label="$I18N('PersionalInfo')" name="tab2">
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("CName")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.attributes && txlUserInfo.attributes.c_name ? txlUserInfo.attributes.c_name : ""
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("EName")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.attributes && txlUserInfo.attributes.e_name ? txlUserInfo.attributes.e_name : ""
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Ethnic")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.attributes && txlUserInfo.attributes.ethnic?txlUserInfo.attributes.ethnic:''
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Country")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.attributes && txlUserInfo.attributes.sap_ppissuecountry?txlUserInfo.attributes.sap_ppissuecountry:''
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("HireType")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    txlUserInfo.attributes && txlUserInfo.attributes.hiretype?txlUserInfo.attributes.hiretype:''
					                  }}</span>
					                </div>
					              </Tab-pane>
					              <Tab-pane :label="$I18N('Position')" name="tab3">
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("EnterAndOrg")
					                  }}</label>
					                  <span class="txl-user-item-info-span" v-if="txlUserInfo.rootOrganization">{{
					                    lang == "zh-Hans"
					                      ? txlUserInfo.rootOrganization.displayName
					                      : txlUserInfo.rootOrganization.enName
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Department")
					                  }}</label>
					                  <span class="txl-user-item-info-span" v-if="txlUserInfo.organizations">{{
					                    lang == "zh-Hans"
					                      ? txlUserInfo.organizations[0].displayName
					                      : txlUserInfo.organizations[0].enName
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Post")
					                  }}</label>
					                  <span class="txl-user-item-info-span">{{
					                    lang == "zh-Hans"
					                      ? txlUserInfo.chPost
					                      : txlUserInfo.enPost
					                  }}</span>
					                </div>
					                <div>
					                  <label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{
					                    $I18N("Area")
					                  }}</label>
					                  <span class="txl-user-item-info-span" v-if="txlUserInfo.attributes">{{
					                    (txlUserInfo.attributes.changzhu &&
					                      txlUserInfo.attributes.changzhu == "01") ||
					                      txlUserInfo.attributes.changzhu == "02"
					                      ? txlUserInfo.attributes.sap_bank_city
					                      : txlUserInfo.attributes.sap_dept_city
					                  }}</span>
					                </div>
									<template v-if="tab=='tab3' && deputyPost">
										<div v-if="txlUserInfo.deputyPostDto && txlUserInfo.deputyPostDto!=null && txlUserInfo.deputyPostDto.length>0" class="deputy-post-title">{{$I18N('副岗位信息')}}
											<img @click="showDeputy=!showDeputy" :style="showDeputy?'':'transform: scaleY(-1);'" class="deputy-img" src="../../images/close.png" />
											
										</div>
										
									<div style="padding:0 10px;"  v-if="deputyPost && txlUserInfo.deputyPostDto && txlUserInfo.deputyPostDto!=null && txlUserInfo.deputyPostDto.length>0 && showDeputy ">
										<div class="deputy-post-item" v-for="item in txlUserInfo.deputyPostDto">
											<div class="linkmancotitem">
												<label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{$I18N('副岗位部门')}}</label>
												<div class="">
													<label v-if="item.organizations && item.organizations.parent">
														{{lang !== 'zh-Hans' && item.organizations && item.organizations.parent && item.organizations.parent.enName!=null && item.organizations.parent.enName!=''?item.organizations.parent.enName: item.organizations.parent.displayName}}
													</label>
													<label v-if="item.organizations">
														{{lang !== 'zh-Hans' && item.organizations && item.organizations.enName!=null && item.organizations.enName!=''?item.organizations.enName: item.organizations.displayName}}
													</label>
													
												</div>
											</div>
											<div class="linkmancotitem">
												<label class="txl-user-item-info-label" :class="lang == 'zh-Hans' ? '' : 'w135'">{{$I18N('副岗位')}}</label>
												<div class="">
													{{lang !== 'zh-Hans'  && item.eName!=null &&  user.eName!=''? item.eName:item.cName}}
												</div>
											</div>
										</div>
									</div>
									</template>
					              </Tab-pane>
					            </Tabs>
					          </div>
					        </div>
					      </div>
					      <div class="home-left1-bottom-qrcode">
					        <div class="appQrcode" v-if="showDownloadAPPQR">
					          <img class="close" src="../../images/close.png" @click.stop="showDownloadAPPQR = false" />
					          <p>{{ $I18N("扫码下载APP") }}<img class="qrcode" src="../../assets/code.png" /></p>
					          
					        </div>
					        <div class="home-left1-bottom-qrcode-show" v-if="!showDownloadAPPQR" @click="showDownloadAPPQR = true">
					          <img src="../../images/close.png" />
					        </div>
					      </div>
					    </div>
					  </div>
				  </div>
			  </template>
			 
		  </Split>
       
        
      </div>
      <div :class=" haoqiUrl && isCanHaoqi?'home-left element':'home-left' " :style="haoqiUrl && isCanHaoqi?'':'margin-right: 0;width: 80%;'">
		  
	     <Split v-model="splitCenter" mode="vertical" @on-move-end="splitCenterChange">
			  <template #top>
				  <div class="demo-split-pane">
					  <div class="home-left-top area-item">
					    <div class="area-item-title">
					      <div class="area-item-title-text">{{ $I18N("应用系统") }}</div>
						  <div class="area-item-title-text-tips"><Icon type="ios-notifications" size="16"/>{{$I18N("鼠标拖动应用进行排序")}}</div>
					    </div>
					    <div class="app-contant">
					      <Tabs :value="tabValue" @on-click="tabChange">
					        <Tab-pane v-for="(tag, index) in tagList" :label="$I18N(tag.tagName)" :name="tag.id">
					        </Tab-pane>
					      </Tabs>
					      <!-- v-if="app.tagId == tag.id || tag.id == 'all'" -->
					      <div class="app-contant-tab-pane" id="app-contant-tab-pane">
					        <div class="app-item" v-for="(app, index) in commonAppList" :key="index" @click="appDetail(index)"
					          v-if="app.tagId == tabValue || tabValue == 'all'" :index="index" :id="app.id" :code="app.applicationId">
					          <div class="app-item-img">
					            <img :src="app.logoUrl" />
					          </div>
							  <Tooltip :content="app.name" style="width: calc(100% - 55px);">
							  
								   <div class="app-item-title">
												 {{ app.name }}						 						  									
								   </div>
							  </Tooltip>	
							  
					        </div>
					      </div>
					    </div>
					  </div>
					  
				  </div>
			  </template>
			  <template #bottom>
				  <div class="demo-split-pane">
					  
						   <Split v-model="splitCenterBottom" mode="vertical" @on-move-end="splitCenterBottomChange">
							  <template #top>
								  <div class="demo-split-pane">
									  <div class="home-left-ceneter">
										  <div class="home-left-ceneter-left area-item">
										    <div class="area-item-title">
										      <div class="area-item-title-text">{{ $I18N("任务列表") }}</div>
										    </div>
										    <div class="task-db-contant">
										      <div class="task-db-list">
										        <div v-for="(wait, index) in waitDoList" :key="index" @click="changeApp(index)" class="task-db-item"
										          :class="wait.appId == wid ? 'task-db-item-active' : ''">
										          <span v-if="wait.totalCount > 0">{{ wait.totalCount }}</span>
										          <img :src="wait.appLogo" />
										          <span> {{ wait.appName }} </span>
										        </div>				
										      </div>
										  					  
										      <div class="task-db-list-contant clearfix">
										        <div class="task-db-list-item" v-for="(item, index) in waitList" :key="index" @click="gotoApp(index)">
										          <div class="backlogtit">
										            <img class="backlogtitimg" :src="item.logo" />
										          </div>
										          <div class="backlogcot">
										            <span class="title">{{ item.name }}</span>
										            <div class="logcotother">
										              {{ $I18N("名称") }}：{{ item.title }}
										            </div>
										          </div>
										        </div>
										      </div>
										    </div>
										  </div>
										  <div class="home-left-ceneter-right area-item">					             
										    <div class="area-item-title">
										      <div class="area-item-title-text">{{ $I18N("ServiceSupport") }}</div>
										    <div class="more" style="cursor: pointer;" @click="showToolIT = true">
										      {{ $I18N("Feedback") }} >>
										    </div>
										    </div>
										    <div class="task-db-contant eventItemWrap">
										      <div class="eventItem" v-for="(item, index) in iscList" :key="item.incidentNumber"  @click="showIscDetail(item.incidentNumber)">
										        <div class="eventNoWrap">
										          <div class="eventNo">{{ $I18N('IncidentNumber') }}：{{ item.incidentNumber }}</div>
										          <div class="eventStatus"><span>{{ $I18N('Status') }}：</span>{{ item.status == undefined || item.status ==
										            ''
										            ? '' :
										            $I18N('ISC_' + item.status)}}</div>
										        </div>
										        <div class="ownerWrap">
										          <div class="owner">{{ $I18N('Owner') }}：{{ item.ownerName == null ? item.owner : item.ownerName }}</div>
										          <div class="urgency"><span>{{ $I18N('Urgency') }}：</span>{{ item.urgency == "" || item.urgency ==
										            undefined
										            ? "" : $I18N('ISC_'+item.urgency)}}</div>
										        </div>
										        <div class="subjectWrap">
										          <div class="subject">{{ item.subject }}</div>
										        </div>
										        <div class="timeWrap">
										          <div class="time">{{ item.createdDateTimeStr }}</div>
										        </div>
										      </div>
										    </div>
										  </div>
										  					         
									   </div>
								  </div>
							  </template>
							  <template #bottom>
								  <div class="demo-split-pane">
									 <div class="home-left-bottom">
										 <div class="home-left-bottom-left area-item" style="height: 100%;">
										   <div class="area-item-title">
										     <div class="area-item-title-text">{{ $I18N("HotQuestions") }}</div>
										     <div class="more" @click="showAnswerList()">{{ $I18N("更多") }} >></div>
										   </div>
										   <div class="task-contant task-contant-hot">
										     <div v-for="(answer, index) in answerList" :key="index" @click="showAnswerDetail(answer.id)"
										       class="task-item" style="padding-left: 8px">
										       <span>{{
										         lanEn
										           ? answer.questionEn == null || answer.questionEn == ""
										             ? answer.question
										             : answer.questionEn
										           : answer.question
										       }}</span>
										     </div>
										   </div>
										 </div>
									  <!-- <div class="home-left-bottom-left area-item">
									     <div class="area-item-title">
									       <div class="area-item-title-text">{{ $I18N("公司新闻") }}</div>
									       <div class="more" @click="showNewsList()">{{ $I18N("更多") }} >></div>
									     </div>
									     <div class="task-contant" style="padding-left: 8px">
									       <div v-for="news in newsList" :key="news.id" @click="showNewsDetail(news.id)" class="task-item"
									         style="padding-left: 8px">
									         <div class="task-item-contant">
									           <span class="task-item-contant-title">{{ news.title }}</span>
									           <span class="task-item-contant-time">{{
									             formatStringToDate(news.creationTime, "yyyy-MM-dd hh:mm:ss")
									           }}</span>
									         </div>
									         <div class="task-item-img">
									           <img class="newimg" :src="news.coverImg" mode="" />
									         </div>
									         <div style="clear: both"></div>
									       </div>
									     </div>
									   </div> -->
								<!-- 	   <div class="home-left-bottom-right area-item">
									     <div class="area-item-title">
									       <div class="area-item-title-text">{{ $I18N("通知") }}</div>
									       <div class="more" @click="showNoticeList()">
									         {{ $I18N("更多") }} >>
									       </div>
									     </div>
									     <div class="task-contant">
									       <div v-for="notice in noticeList" :key="notice.id" class="task-item" style="padding-left: 8px"
									         @click="showNewsDetail(notice.id)">
									         <div class="task-item-contant">
									           <span class="task-item-contant-title">{{
									             notice.title
									           }}</span>
									           <span class="task-item-contant-time">{{
									             formatStringToDate(
									               notice.creationTime,
									               "yyyy-MM-dd hh:mm:ss"
									             )
									           }}</span>
									         </div>
									         <div class="task-item-img">
									           <img class="newimg" :src="notice.coverImg" mode="" />
									         </div>
									         <div style="clear: both"></div>
									       </div>
									     </div>
									   </div> -->
									   <div  class="home-left-bottom-right area-item">
									     <div v-if="intranet" class="area-item-title">
									       <div class="area-item-title-text">{{ $I18N("常用信息") }}</div>
									       <div class="more" @click="showDirectories()">
									         {{ $I18N("更多") }} >>
									       </div>
									     </div>
									     <div  v-if="intranet" class="task-contant">
									       <div v-for="(doc, index) in currentDocuments" :key="index" @click="showDocDetail(doc)"
									         class="task-item" style="padding-left: 8px">
									         <span>{{doc.name}}</span>
									       </div>
									     </div>
									   </div>
									 </div>
								  </div>
							  </template>
							 
						  </Split>
					           
					         
				  </div>
			  </template>
				 
		  </Split>
		  
        
      </div>
	 <div :class="haoqiUrl && isCanHaoqi?'home-right slide-in-right':'home-right'" :style="haoqiUrl && isCanHaoqi?'':'display:none'">
	 		  
	 		  <div class="demo-split-pane" style="position: relative;">
	 			  <div class="home-right-top area-item" style="height: 100%;">
	 				<div class="area-item-title" v-if="isCanHaoqi">
	 				  <div class="area-item-title-text">{{ $I18N("AI") }}</div>
	 				  <div class="more" @click="goHaoqi">{{ $I18N("使用完整功能") }} >></div>
	 				</div>
	 				<div class="haoqi-contant" v-if="haoqiUrl && isCanHaoqi" :style="'background: #f6f6f6;'">
	 				  <div style="line-height: 40px;text-align: center;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ $I18N("以下是您最近的对话，请点击右上角使用完整功能按钮体验更多") }}</div>
	 				  <iframe id="haoqiiframe" :src="haoqiUrl"  :style=" 'border: 0;height:calc(100% - 40px);width:100%;' " allow="microphone"></iframe>
	 				</div>
	 			  </div>
	 			  
	 			    <div v-if="showModal" style="position:absolute;top:0;right:0;bottom: 0;left:0;z-index: 999;background:rgba(255,255,255,0.6);"></div>
	 		  </div>
	 		  
	 		  <!-- <Split v-model="splitRight" mode="vertical" @on-move-end="splitRightChange" @on-move-start="splitRightStart">
	 			  <template #top>
	 				  
	 			  </template>
	 			 <template #bottom>
	 				  <div class="demo-split-pane">
	 					  <div class="home-right-bottom area-item" style="height: 100%;">
	 					    <div class="area-item-title">
	 					      <div class="area-item-title-text">{{ $I18N("HotQuestions") }}</div>
	 					      <div class="more" @click="showAnswerList()">{{ $I18N("更多") }} >></div>
	 					    </div>
	 					    <div class="task-contant task-contant-hot">
	 					      <div v-for="(answer, index) in answerList" :key="index" @click="showAnswerDetail(answer.id)"
	 					        class="task-item" style="padding-left: 8px">
	 					        <span>{{
	 					          lanEn
	 					            ? answer.questionEn == null || answer.questionEn == ""
	 					              ? answer.question
	 					              : answer.questionEn
	 					            : answer.question
	 					        }}</span>
	 					      </div>
	 					    </div>
	 					  </div>
	 				  </div>
	 			  </template>
	 			 
	 		   </Split> -->
	 </div>
      
    </div>

    <div class="popup" v-if="showTips">
      <div class="wrongBox">
        <div class="title">{{ $I18N("InformationWrongTipsTile") }}</div>
        <pre>{{ $I18N("InformationWrongTips") }}</pre>
        <img @click="showTips = false" class="close" src="../../images/close1.png" />
      </div>
    </div>
	<div class="popup" v-show="showScan">
	  <div class="wrongBox" style="text-align: center;">
		 <div class="title-qrcode">{{ lang == 'zh-Hans' ? showCode.chs : showCode.en }}</div>
	     <div id="qrcode-container">
			   <div id="finalCanvas" ref="finalCanvas">
				   
			   </div>
		   </div>
		   <div class="download-area">
			   <button class="download-btn" id="downloadPNG" @click="downloadPNG">
				   <i>⬇️</i> {{ lang == 'zh-Hans' ? download.chs : download.en }}
			   </button>			  
		   </div>
		   <img @click="showScan = false" class="close" src="../../images/close1.png" />
	  </div>
	</div>
	
	<Modal
	  v-model="showToolIT"
	  :mask-closable="false"
	  :title="$I18N('ServiceSupport')"
	  @on-ok="saveFile"
	  @on-cancel="cancelFile"
	  :ok-text="$I18N('提交')"
	>
	  <Form
	    ref="toolForm"
	    :rules="rules"
	    :model="updateTool"
	    label-position="top"
	  >
	    <FormItem
	      :label="$I18N('ReportForRepairs')"
	      prop="question"
	      style="width: 100%; font-size: 14px"
	    >
	      <Input
	        v-model="updateTool.question"
	        style="width: 100%"
	        :placeholder="$I18N('请输入')"
	      ></Input>
	    </FormItem>
	    <FormItem
	      :label="$I18N('ReportContent')"
	      prop="description"
	      style="width: 100%; font-size: 14px"
	    >
	      <textarea
	        v-model="updateTool.description"
	        style="width: 100%"
	        :placeholder="$I18N('请输入')"
			class="bxTextArea"
	      ></textarea>
	    </FormItem>
	    <FormItem label=" ">
	      <div
	        v-show="imagebox"
	        class="upload-list"
	        v-for="(item, index) in toolPics"
	      >
	        <template>
	          <img :src="item" />
	          <div class="upload-list-cover">
	            <Icon
	              type="ios-trash-outline"
	              @click.native="handleRemove(index)"
	            ></Icon>
	          </div>
	        </template>
	      </div>
	      <Upload
	        ref="upload"
	        :show-upload-list="true"
	        :on-success="handleSuccess"
	        :format="['jpg', 'jpeg', 'png']"
	        :max-size="2048"
	        :before-upload="handleUpload"
	        type="drag"
	        action=""
	        style="display: inline-block; width: 60px; vertical-align: middle"
	      >
	        <div
	          style="
	            width: 60px;
	            height: 60px;
	            line-height: 60px;
	            vertical-align: middle;
	          "
	        >
	          <img
	            src="../../images/addImage.png"
	            style="width: 25px; height: 25px"
	          />
	        </div>
	      </Upload>
	    </FormItem>
	  </Form>
	  <hr />
	  <div>
	    <!-- <p>请注意:</p>
	    <p>1.请在这里提交您的报修信息;</p>
	    <p>2.信息提交后会传递到ISC做后续支持;</p> -->
	    <p>{{$I18N('PleaseNote')}}</p>
	    <p>{{$I18N('PleaseNote1')}}</p>
	    <p>{{$I18N('PleaseNote2')}}</p>
	  </div>
	  <div slot="footer">
	    <Button @click="cancelFile">{{ $I18N("Cancel") }}</Button>
	    <Button @click="saveFile" type="primary">{{ $I18N("FeedbackSubmit") }}</Button>
	  </div>
	</Modal>
  </div>
</template>

<script>
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import util from "../../lib/util";
import appconst from "../../lib/appconst";
import url from "../../lib/url";
import Util from "@/lib/util";
import axios from 'axios';
import {Sortable} from "sortablejs"
import QRCode from 'easyqrcodejs';
import logoImg from '@/assets/YFPO_Logo.png'; 
// import DocumentList from '../../components/DocumentList.vue'

export default {
	props: {},
	components: {
			
	},
	created() {
	  var that = this;
	  if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
	    that.lang = "en";
	  } else {
	    that.lang = "zh-Hans";
	  }
	  
	  setInterval(function () {
	     document.cookie = "Abp.UserInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	  }, 1000 * 5);
	
	  var appCode = this.getQueryVariable("appCode");
	  if (appCode != undefined && appCode != "") {
	    this.checkBrowser();
	    var that = this;
	    this.$store
	      .dispatch({
	        type: "app/getAppByCode",
	        data: {
	          code: appCode,
	        },
	      })
	      .then((res) => {
	        var app = res.data.result;
	        var supportBrowsers = JSON.parse(app.property).SupportBrowsers;
	        var url = app.url;
	        if (
	          this.isIE &&
	          supportBrowsers.length == 1 &&
	          supportBrowsers[0].toLowerCase() == "chrome"
	        ) {
	          url = "openChrome:" + url;
	        }
	        if (
	          this.isChrome &&
	          supportBrowsers.length == 1 &&
	          supportBrowsers[0].toLowerCase() == "ie"
	        ) {
	          url = "openIE:" + url;
	        }
	        location.href = url;
	      });
	  } else {		
	    that.pageLoad();
		  setInterval(function () {
		    let authTime = (localStorage ).getItem("authTime") * 1;
		    var span = new Date().getTime() - authTime;
		    console.log(span);
		    if (span * 1 > 1000 * 60 * 20) {
		      that.pageLoad();
		      //window.location.reload();
		    }
		  }, 1000 * 60 * 20);
		  
		  if(localStorage.getItem("splitCenterBottom")){
			  this.splitCenterBottom= parseFloat(localStorage.getItem("splitCenterBottom")) ;
		  }
		  if(localStorage.getItem("splitCenter")){
		  	  this.splitCenter= parseFloat(localStorage.getItem("splitCenter")) ;
		  }
		  
		  if(localStorage.getItem("splitLeft")){
		  	  this.splitLeft= parseFloat(localStorage.getItem("splitLeft")) ;
		  }
		  else{
			  var ft=210/(window.innerHeight-50);
			  this.splitLeft=ft;
		  }
		  
		  if(localStorage.getItem("splitRight")){
		  	  this.splitRight= parseFloat(localStorage.getItem("splitRight")) ;
		  }
		  else{
			  
			  this.iframeWidth=window.innerWidth*0.25-26;
			  if(this.iframeWidth*this.iframeRate<500){
			  	this.iframeHeight=window.innerHeight*0.55;
			  }
			  else{
			  	this.iframeHeight=this.iframeWidth*this.iframeRate;
			  }
			  console.log("iframeHeight:"+ this.iframeHeight)
			  
			  var ft=(this.iframeHeight+100)/(window.innerHeight-50);
			  this.splitRight=ft;
		  }
		  
		 
		
		  
	    setTimeout(function () {
	      //删除链接domain参数
	      that.replaceHashParameter("domain");
			
			that.replaceHashParameter("id_token");
	    }, 1000);
	    //this.getWaitNewsApplication();
	   
	  }
	},
	
	mounted() {
		
	},
	beforeDestroy() {
		
	},
	watch: {
	
	},
	data() {
		var _this = this;
		return {
			tab:'tab1',
			showDeputy:true,
			deputyPost:true,
			waitDoList: [],
			waitList: [],
			newsList: [],
			noticeList: [],
			mineAppList: [],
			commonAppList: [],
			newCommonAppList: [],
			appList: [],
			tagList: [],
			waitNewsList: [],
			wid: 0,
			userInfo: {},
			department: {},
			org: {},
			showPhone: false,
			showTips:false,
			showDownloadAPPQR: true,
			domainAccount: "",
			defaultImg:  'this.src="../../images/renyuan.png"',
			
			isIE : false,
			isChrome : false,
			activeTag: 0,
			answerList: [],
			lanEn : false,
			// 应用程序当前tab
			currentTab: "all",
			haoqiUrl: "",
			isCanHaoqi:false,
			isCanBook:false,
			// 通讯录
			treeData: [],
			txlUserList: [],
			fliterTxlUser: [],
			isShowWB:false,
			txlUserInfo: {},
			lang:  "zh-Hans",
			txlInputValue: "",
			isShowSerch:false,
			orgDate: [],
			orgAllList: [],
			treeId: null,
			// 员工必读
			menuList: [],
			noReadData: [],
			mustReadList: [],
			activeMenuName:  null,
			iframeWidth:0,
			iframeHeight:0,
			iframeRate:1.35,
			splitLeft:0.3,
			splitCenter:0.40,
			splitCenterBottom:0.55,
			splitRight:0.65,
			showModal:false,
			showScan:false,
			scanImgUrl:"",
			
			//it报修列表
			iscList: [],
			
			tabValue:  "all",
			
			showToolIT:false,
			updateTool: {},
			toolPics: [],
			imagebox:false,
			rules : {
			  question: [
			    {
			      required: true,
			      message: this.$I18N("标题不能为空"),
			      trigger: "blur",
			    },
			  ],
			  description: [
			    {
			      required: true,
			      message: this.$I18N("描述不能为空"),
			      trigger: "blur",
			    },
			  ],
			},
					
			showMyCode: {
				en: "Show My QR Code",
				chs: "显示我的二维码"
			},
			showCode: {
				en: "My QR Code",
				chs: "我的二维码"
			},
			download: {
				en: "Download",
				chs: "下载"
			},
			currentDocuments:[],
			selectedId:0,
			
			intranet:true,//内网
		}
	},
	methods: {
		getAllDirectories() {
			var that = this;			
			this.$store.dispatch({
				type: 'app/getTop6DirAndLinks',
				data: {}
			}).then(res => {
				console.log(res);				
				var result = res;
				this.currentDocuments=result;
			})
		},
	
		downloadByName(name){
			var that = this;
			
			this.$store.dispatch({
				type: 'app/downloadDirDoc',
				data: {
					Id:this.selectedId,
					filePath:name
				}
			}).then(res => {
				console.log(res);			
				
			})
		},
		downloadPNG() {
			 const qrCanvas = this.$refs.finalCanvas;
			 const canvas = qrCanvas.querySelector('canvas');
			  // 如果库生成的是 img 标签而不是 canvas (取决于配置)
			  const link = document.createElement('a');
			  link.download = `my-qrcode_${Date.now()}.png`;
			  // 直接从finalCanvas输出
			  link.href = canvas.toDataURL('image/png');
			  link.click();
			   return;
		},
		// 假设这是在 methods 或 mounted 中
		generateQRCode() {
		  // 1. 获取 Canvas 元素
		  const qrCanvas = this.$refs.finalCanvas;
		 
		
		  // 【检查点 1】Canvas 是否存在？
		  if (!qrCanvas) {
		    console.error('❌ 错误: 找不到 ref="finalCanvas" 的元素。请检查模板中是否有 <canvas ref="finalCanvas">');
		    return;
		  }
		
		  // 【检查点 2】Canvas 尺寸是否有效？(如果父元素 display:none 或宽度为0，会导致绘制失败)
		  if (qrCanvas.offsetWidth === 0 || qrCanvas.offsetHeight === 0) {
		    console.warn('⚠️ 警告: Canvas 当前宽度或高度为 0。请确保父容器已显示且设置了宽高。');
		    // 尝试强制设置尺寸以防万一
		    qrCanvas.width = 200;
		    qrCanvas.height = 200;
		  }
		   qrCanvas.innerHTML = ''; 
		
		  // 【检查点 3】logoImg 到底是什么？
		  console.log('🔍 当前 logoImg 的值:', logoImg);
		  
		  if (!logoImg) {
		    console.error('❌ 错误: logoImg 是 undefined 或 null。请检查图片引入路径。');
		    // 如果没有 logo，先尝试不带 logo 生成，看二维码是否出现
		    // logoImg = null; 
		  }
		
		  // 2. 创建二维码实例
		  try {
			  var scanContent=this.userInfo.namedd+"\n"+ "部门：" + this.org.namedd+"\n科室："+this.department.namedd+"\n岗位："+this.userInfo.postdd+"\n手机号："+this.userInfo.phoneNumber
			  +"\n短号："+this.userInfo.cornet+"\n邮箱："+this.userInfo.emailAddress;
		    const qrObject = new QRCode(qrCanvas, {
		      text: scanContent,
		      width: 220,
		      height: 220,
		      correctLevel: QRCode.CorrectLevel.H,
		      
		      // --- Logo 配置 ---
		      // 如果 logoImg 无效，库可能会静默失败。确保它是 string (url/base64) 或 Image 对象
		      logo: logoImg, 
		      logoWidth: 60,
		      logoHeight: 40,
		      logoBackgroundTransparent: false,// Logo 背景透明
		      
		      // --- 样式配置 ---
		      colorDark: '#000000',
		      colorLight: '#ffffff',
		      quietZone: 10,
		    });
			  this.showScan=true;
		
		    console.log('✅ 二维码对象已创建:', qrObject);	 
		  } catch (error) {
		    console.error('💥 生成过程抛出异常:', error);
		  }
		},
 
  
  splitLeftChange(){
	 localStorage.setItem('splitLeft',this.splitLeft.toFixed(2));
  },
  splitCenterChange(){	  
	  localStorage.setItem('splitCenter',this.splitCenter.toFixed(2));
  },
  splitCenterBottomChange(){  	 
	  localStorage.setItem('splitCenterBottom',this.splitCenterBottom.toFixed(2));
  },
  splitRightChange(){
	   this.showModal=false;
	  localStorage.setItem('splitRight',this.splitRight.toFixed(2));
  },
  splitRightStart(){
	  this.showModal=true;
  },
  async upload(file) {
    let that = this;
    var form = new FormData();
    form.append("file", file);
    var res = await this.$store
      .dispatch({
        type: "app/uploadImage",
        data: form,
      })
      .then((res) => {
        that.toolPics.push(res);
        that.imagebox = true;
      });
  },
  handleRemove(index) {
    this.toolPics.splice(index, 1);
  },
  handleSuccess(res, file) {},
  handleUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    if (fileExt === "jpeg" || fileExt === "jpg" || fileExt === "png") {
      this.upload(file);
    } else {
      this.$Notice.warning({
        title: this.$I18N("文件类型错误"),
        desc: this.$I18N("文件不是图片").replace("{0}", file.name),
      });
    }
    return false;
  },
  async saveFile() {
    (this.$refs.toolForm).validate(async (valid) => {
      if (valid) {
        this.$Message.loading({
          content: this.$I18N("报修中"),
          duration: 0,
        });
        const params = Object.assign(
          {
            pictures: this.toolPics.join(","),
            type: 2,
          },
          this.updateTool
        );
        var res = await this.$store
          .dispatch({
            type: "app/createAnswer",
            data: params,
          })
          .then((res) => {
            if (res.success) {
  				this.$Message.success(this.$I18N("报修提交成功"));
              this.cancelFile();
            } else {
              this.$Message.error(this.$I18N("报修提交失败"));
            }
          })
          .finally(() => {
            this.$Message.destroy();
          });
      }
    });
  },
  cancelFile() {
    (this.$refs.toolForm ).resetFields();
    this.updateTool = {};
    this.toolPics = [];
    this.showToolIT = false;
  },

  tabChange(e) {
    this.tabValue = e;
	if(this.newCommonAppList.length>0){
		this.commonAppList=JSON.parse(JSON.stringify(this.newCommonAppList));
	}
  },

  onImageError(event) {
    event.target.onerror = null;
    event.target.src = '/images/renyuan.png';
  },

  showMustReadDetail(item) {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    let isen = this.lang == "zh-Hans" ? 0 : 1;
    window.open(
      "#/mustReadDetail?readid=" +
      item.id +
      "&isen=" +
      isen +
      "&userid=" +
      user.id
    );
  },

  async getMustReadClassify() {
    const params = {
      isAppUser: true,
      orderType: 1,
    };
    let newmenuList = await this.$store.dispatch({
      type: "app/getMustReadClassify",
      data: params,
    });
    let newnoReadData = await this.$store.dispatch({
      type: "app/getClassifyNoReadCount",
    });

    newmenuList &&
      newmenuList.items.forEach((menu) => {
        menu.count = 0;
        let fid = newnoReadData.find((item) => item.id == menu.id);
        if (fid) {
          menu.count += fid.count;
        }
        if (menu.childrenList) {
          menu.childrenList.forEach((menuSub) => {
            let fid = newnoReadData.find((item) => item.id == menuSub.id);
            if (fid) {
              menuSub.count = fid.count;
              menu.count += fid.count;
            }
          });
        }
      });
    this.menuList = newmenuList.items;

    this.activeMenuName = this.menuList[0].id;

    this.getMustRead(this.menuList[0].childrenList[0].id);

    // this.$refs.menu.updateOpened();
    // this.$refs.menu.currentActiveName = this.openMeneName
  },

  getMustRead(id) {
    const params = {
      skipCount: 0,
      maxResultCount: 10000,
      isAppUser: true,
      status: "OP",
      tagId: id,
      lang: abp.utils.getCookieValue("Abp.Localization.CultureName"),
    };
    this.$store
      .dispatch({
        type: "app/getMustRead",
        data: params,
      })
      .then((res) => {
        this.mustReadList = res.items || [];
      });
  },

  txlInputChange(e) {
    console.log("txlInputChange===========>", e);
    //this.txlInputValue = e;
    if (this.treeId) {
      //this.fliterTxl();
	  this.getUserByOrgId(this.treeId);
    } else {
      this.getUser();
    }
  },
  changeShowSearch() {
    this.isShowSerch = !this.isShowSerch;
    if (!this.isShowSerch) {
      this.txlInputValue = null;
    }
  },

  changeShowWB() {
    this.isShowWB = !this.isShowWB;
    if (this.treeId) {
      this.getUserByOrgId(this.treeId);
    } else {
      this.getUser();
    }
  },

  fliterTxl() {
    this.txlUserList = this.fliterTxlUser.filter((item) =>
      item.name.includes(this.txlInputValue)
    );
  },

  fliterTxlUserList() {
    if (this.treeId) {
      this.fliterTxl();
    } else {
      this.getUser();
    }
  },
  getTxlUserInfo(userId) {
    var that = this;
    var request = {
      id: userId,
    };
    this.$store
      .dispatch({
        type: "user/get",
        id: userId,
      })
      .then((res) => {
        that.txlUserInfo = res ;
		that.$forceUpdate();
      });
  },
  toggle(index, user) {
    this.getTxlUserInfo(user.id);
	this.loadDeputyPost();
    this.txlUserList.forEach((item, i) => {
      if (i == index && item.isShowInfo) {
        this.$set(this.txlUserList[i], "isShowInfo", false);
      } else {
        this.$set(this.txlUserList[i], "isShowInfo", i === index);
      }
    });
  },
  loadDeputyPost() {
  	var that = this;
  	that.$store.dispatch({
  		type: 'app/getDeputyPostSetting',
  	}).then((res) => {
  		if(res.code==0){
  			that.deputyPost=res.msg=="show";
  		}
  		else{
  			that.deputyPost=true;
  		}
  		
  		that.$forceUpdate();
  	})
  },
  changeTreeId(item) {	 
    //this.treeId = item.id;
	console.log("changeTreeId")
	if (this.treeId) {
	  this.getUserByOrgId(this.treeId);
	} else {
	  this.getUser();
	}
  },  
  goHaoqi() {
    var curlurl = localStorage.getItem("curl_url");
    if (curlurl != "" && curlurl != "") {
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      window.open(curlurl, "_blank");
    } else {
      if (url.toLocaleLowerCase().indexOf("gistest") > -1) {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl =
          "https://gistest.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      } else {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl = "https://gis.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      }
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      console.log(curlurl);
      window.open(curlurl, "_blank");
    }
  },
  changeTag(tag) {
    this.currentTab = tag.id;
  },
  getWaitDoMsgByUserId() {
    var pagerequest = {
      MaxResultCount: 6,
      SkipCount: 0,
      Client: 2,
    };
    let that = this;
    this.$store
      .dispatch({
        type: "app/getWaitDoMsgByUserId",
        data: pagerequest,
      })
      .then((res) => {
      
        var newlist = res.items;
        // var waitNew = [];
        // for (var i = 0; i < newlist.length; i++) {
        //   for (var j = 0; j < that.commonAppList.length; j++) {
        //     if (that.commonAppList[j].id == newlist[i].appId) {
        //       if (that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1) {
        //         waitNew.push(newlist[i]);
        //       }
        //     }
        //   }
        // }
		
		var waitNew = [];		
		
		for (var i = 0; i < newlist.length; i++) {			
			var has=false;			
			for (var j = 0; j < that.waitDoList.length; j++) {
			  if (that.waitDoList[j].appId == newlist[i].appId) {
				  has=true;
			    that.waitDoList[j].totalCount= newlist[i].totalCount;
				that.waitDoList[j].waitDoMsg=newlist[i].waitDoMsg;
			  }
			}
			if(!has){
				
				for (var j = 0; j < that.commonAppList.length; j++) {
				  if (that.commonAppList[j].id && newlist[i].appId== that.commonAppList[j].id) {
					  if(that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1 || (that.commonAppList[j].supportDeviceTypes.indexOf("WEB") > -1 && that.commonAppList[j].description && that.commonAppList[j].description.indexOf('authorization_code')>-1) ){
						  that.waitDoList.push(newlist[i]);
					  }
				   
				  }
				}
			}
		  
		}
		
		this.waitDoList.sort((a, b) => { return b.totalCount - a.totalCount  });
		
        // that.waitDoList = waitNew;
        var index = 0;
        if (that.waitDoList.length > 0) {
          if (that.wid > 0) {
            for (var i = 0; i < that.waitDoList.length; i++) {
              if (that.wid == that.waitDoList[i].appId) {
                index = i;
                // that.appName = that.waitDoList[i].appName;
              }
            }
          } else {
            // that.appName = that.waitDoList[0].appName;
            that.wid = that.waitDoList[0].appId;
            index = 0;
          }
        }
        //that.scrollView = that.appName;
        // console.log(that.waitList);
        that.changeApp(index);
      });
  },
  isString(data) {
      return typeof data === 'string';
  },
  appDetail(index) {
    var app = this.commonAppList[index];
    if (app.isfixed) {
      //固定菜单，直接跳转
      if (app.name == "员工必读") {
        window.open("#/mustreadList");
      }
    } else {
      this.checkBrowser();
      var supportBrowsers = [];
      if (app.property) {
		  if(this.isString(app.property)){
			  var jsonproperty=JSON.parse(app.property)
			  supportBrowsers = jsonproperty.SupportBrowsers;			 
		  }
		  else{
			  supportBrowsers = app.property.SupportBrowsers;
		  }
        
      } else {
        supportBrowsers = app.supportDeviceTypes;
      }
      var url = app.startUrl;
      var browser = "";
      console.log(url);
	  if(app.description.indexOf('authorization_code')>-1){		
		  url=url.replace("/api/enduser/sso/","/enduser/").replace("/api/enduser/portal/sso/","/enduser/");
		  url=url.split('?')[0];
		  console.log(url)
		 window.open(url);
		 return false;
	  }

      if (
        this.isIE &&
        supportBrowsers.length == 1 &&
        supportBrowsers[0].toLowerCase() == "chrome"
      ) {
        url = "openChrome:" + url;
        browser = "Chrome";
      }
      if (
        this.isChrome &&
        supportBrowsers.length == 1 &&
        supportBrowsers[0].toLowerCase() == "ie"
      ) {
        url = "openIE:" + url;
        browser = "IE";
      }

      if (browser != "") {
        var alerthtml =
          "温馨提示 Notice \\n该应用需使用" +
          browser +
          "浏览器才可访问，如仅见此页面，说明调用" +
          browser +
          "浏览器功能异常 \\n请手工打开" +
          browser +
          "浏览器登录GIS主页，再点击应用图标进行访问！\\nThe application needs to use " +
          browser +
          " browser to work normally. If you only see this page, it indicates that calling " +
          browser +
          " browser function is abnormal.\\nPlease manually open the  " +
          browser +
          " browser, log in to the GIS home page, and then click the application icon to access.";

        var newpage = window.open(url);

        setTimeout(function () {
          newpage.document.write(
            '<script> setTimeout(function(){if(document.body==null || document.body.innerHTML.trim()==""){alert("' +
            alerthtml +
            '");window.close(); }   },"4000");  </' +
            "script>"
          );
        }, 4000);
      } else {
        window.open(url);
      }
    }
  },
  checkBrowser() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) this.isIE = true;
    if (window.navigator.userAgent.indexOf("Chrome") != -1) {
      this.isChrome = true;
    }
  },
  gotoApp(index) {
    var item = this.waitList[index];
    console.log(item);
    var that = this;
    var idpToken = localStorage.getItem("idptoken");
    //localStorage.setItem("website", "W3Cfuns.com"); location.getStorageSync uni.getStorageSync("idptoken");
    var url = this.changeUrlArg(item.url, "access_token", idpToken);

    var url2 = this.changeUrlArg(url, "domain", that.domainAccount);

    console.log("gotoApp===url2===>", url2);

    window.open(url2);
    // uni.navigateTo({
    // 	url: '/pages/webview/webview?path=' + encodeURIComponent(url)
    // });
  },
  changeUrlArg(url, arg, val) {
    var pattern = arg + "=([^&]*)";
    var replaceText = arg + "=" + val;
    return url.match(pattern)
      ? url.replace(eval("/(" + arg + "=)([^&]*)/gi"), replaceText)
      : url.match("[\?]")
        ? url + "&" + replaceText
        : url + "?" + replaceText;
  },
  newsTO3Col() {
    const columns = 3;
    const result = Array.from({ length: columns }, () => []);
    this.answerList.forEach((item, index) => {
      result[index % columns].push(item);
    });
    return result;
  },
  getNewsList() {
    var that = this;
    var pageNewsRequest = {
      SkipCount: 0,
      MaxResultCount: 6,
      TagType: 4,
      Status: "OP",
      // TagId: 4,
    };
    this.$store
      .dispatch({
        type: "app/getNewsList",
        data: pageNewsRequest,
      })
      .then((res) => {
       
		var list=[];
        for (var i = 0; i < res.items.length; i++) {
          if (res.items[i].coverImg != null) {
            res.items[i].coverImg = res.items[i].coverImg.replace(
              "http:",
              "https:"
            );
          }
          list.push(res.items[i]);
        }
		 that.newsList = list;
      });
  },
  getISCList() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getISCList"
      })
      .then((res) => {
		 
        that.iscList = res;
      });
  },
  getNoticeList() {
    var that = this;
    var pageNoticeRequest = {
      SkipCount: 0,
      MaxResultCount: 6,
      // TagType: 4,
      // TagId: 7,
    };
    this.$store
      .dispatch({
        type: "app/getWaitDoNewsByUserID",
        data: pageNoticeRequest,
      })
      .then((res) => {
		var list=[];
        for (var i = 0; i < res.items.length; i++) {
          if (res.items[i].coverImg != null) {
            res.items[i].coverImg = res.items[i].coverImg.replace(
              "http:",
              "https:"
            );
          }

         list.push(res.items[i]);
        }
		that.noticeList=list;
        //that.noticeList = res.items;
      });
  },
  getApplicationList() {
    var that = this;
    var pageAppRequest = {
      SkipCount: 0,
      MaxResultCount: 100,
    };
    this.$store
      .dispatch({
        type: "app/getApplicationList",
        data: pageAppRequest,
      })
      .then((res) => {
        that.appList = [];
        var appList = res.items;
        // console.log(appList);
        var list_tag = [];
        for (var i = 0; i < appList.length; i++) {
          that.appList.push(appList[i]);
          if (appList[i].showAPP) {
            var arr = new Object() ;
            arr.id = appList[i].tagId + "";
            if (appList[i].tag != null) {
              arr.tagName = appList[i].tag.key;
			  list_tag.push(arr);
            }
            
          }
        }
        var temp = {}; //用于name判断重复
        var result = [
          {
            id: "all",
            tagName: "全部",
          },
        ]; //最后的新数组
        list_tag.map(function (item, index) {
          if (!temp[item.id]) {
            result.push(item);
            temp[item.id] = true;
          }
        });
		console.log(result);
        that.tagList = result;
        that.getApplicationByUser();
      });
  },
  getApplicationByUser() {
    var that = this;

    that.mineAppList = [];
    this.$store
      .dispatch({
        type: "app/getApplicationByUserId",
        data: {},
      })
      .then((res) => {
        if (res.data.success) {
          // console.log(JSON.stringify(res.data.result))
          localStorage.removeItem("idpRetryTimes");
          var curlUrl = "";
		  var msort=0;
          for (var i = 0; i < res.data.result.length; i++) {
            // if ((res.data.result[i].supportDeviceTypes.indexOf("WEB") > -1 ||
            // 		res.data.result[i].supportDeviceTypes.indexOf("PC") > -1) &&
            // 	res.data.result[i].applicationId != 'yfjwt5' &&
            // 	res.data.result[i].enabled && res.data.result[i].display) {
            // 	that.mineAppList.push(res.data.result[i]);
            // }
			if(res.data.result[i].description && (res.data.result[i].description.toLowerCase().startsWith("saml") || res.data.result[i].description.toLowerCase().startsWith("oauth2")) ){
				res.data.result[i].pageSort=msort;
				that.mineAppList.push(res.data.result[i]);
				msort++;
			}
            else if (
              res.data.result[i].supportDeviceTypes.indexOf("PC") > -1 &&
              res.data.result[i].applicationId != "yfjwt5" &&
              res.data.result[i].enabled &&
              res.data.result[i].display
            ) {
				
				res.data.result[i].pageSort=msort;
              that.mineAppList.push(res.data.result[i]);
			  msort++;
            }
            if (
              window.location.hostname.toLocaleLowerCase().indexOf("gistest") >
              -1
            ) {
              if (res.data.result[i].applicationId == "yfjwt2") {
                curlUrl = res.data.result[i].startUrl;
              }
            } else if (res.data.result[i].applicationId == "yfjwt38") {
              curlUrl = res.data.result[i].startUrl;
            }
            if (url.indexOf("gistest.yfpo.com") != -1) {
              //测试
              if (res.data.result[i].applicationId == "yfjwt2") {
                that.haoqiUrl = res.data.result[i].startUrl;
              }
            } else {
              //正式
              if (res.data.result[i].applicationId == "yfjwt38") {
                that.haoqiUrl = res.data.result[i].startUrl;
              }
            }
          }
          for (var i = 0; i < that.appList.length; i++) {
            that.appList[i].isClick = false;
            for (var j = 0; j < that.mineAppList.length; j++) {
              if (that.appList[i].code == that.mineAppList[j].applicationId) {
                that.appList[i].isClick = true;
				
                that.appList[i].url = that.mineAppList[j].startUrl;
                that.mineAppList[j].logoUrl = that.appList[i].logoUrl.replace(
                  "http:",
                  "https:"
                );
				
				
				that.mineAppList[j].apiUrl=that.appList[i].apiUrl;

                that.mineAppList[j].tagId = that.appList[i].tagId;
                that.mineAppList[j].id = that.appList[i].id;
				
                if (
                  that.appList[i].property == null ||
                  that.appList[i].property == "" || that.appList[i].property == undefined
                )
                  that.appList[i].property = "{}";
                that.mineAppList[j].property = JSON.parse(
                  that.appList[i].property
                );
              }
            }
            if (!that.appList[i].isClick) {
              that.appList[i].url = "";
            }
          }
		  
		  var waitNew = [];
		  
		 
		  
          that.commonAppList = that.mineAppList;
          localStorage.setItem("curl_url", that.haoqiUrl);
		  // console.log(that.commonAppList)
		  var sortable= new Sortable(document.getElementById('app-contant-tab-pane'), {
			  animation: 300, // 动画时间，单位毫秒
			  ghostClass: 'sortable-ghost', // 拖动时的幽灵类名
			  onEnd: function (/**Event*/evt) { // 当拖拽结束时触发的事件
				  const itemEl = evt.item; // 当前被拖拽的元素
				  const newsort=evt.newIndex;
				  const oldsort=evt.oldIndex;
				  const appid=itemEl.id.toString();
				  const code=itemEl.getAttribute("code");
				  const index = parseInt(itemEl.getAttribute("index"));
				  
				  console.log(appid+","+code+","+newsort+","+oldsort);
				  var kkst=0;
				 
				  for(var p=0;p<that.commonAppList.length;p++){
					  if(appid == that.commonAppList[p].id.toString()){
					  	that.commonAppList[p].pageSort=JSON.parse(JSON.stringify(newsort));	
					  }
					  else{
						  if(newsort>oldsort){							 
							  if(that.commonAppList[p].pageSort>=oldsort && that.commonAppList[p].pageSort<=newsort){
								that.commonAppList[p].pageSort=that.commonAppList[p].pageSort-1;		
							  }		
						  }
						  else{							
						  	if(that.commonAppList[p].pageSort>=newsort && that.commonAppList[p].pageSort<oldsort){
						  		that.commonAppList[p].pageSort=that.commonAppList[p].pageSort+1;		
						  	}
						  }
					  }
					  
				  }
				 
				 //  that.commonAppList.forEach((item) => {				   
					// if(appid == item.id.toString()){
					// 	item.pageSort=JSON.parse(JSON.stringify(newsort));	
					// }
					// else{
					// 	if(newsort>oldsort){
					// 		if (item.pageSort>=newsort) {
					// 		   item.pageSort=JSON.parse(JSON.stringify(item.pageSort-1));					   
					// 		}
					// 	}
					// 	else{							
					// 		if (item.pageSort<oldsort) {
					// 		   item.pageSort=JSON.parse(JSON.stringify(item.pageSort-1));			   
					// 		}
					// 	}
					
					// }					
				 //  });
				 
				 var newls= JSON.parse(JSON.stringify(that.commonAppList))
				  that.newCommonAppList = newls.sort((a,b)=>{
				  		return a.pageSort - b.pageSort;
				  })
				  
				  // that.newCommonAppList.forEach((item) => {
				  //   console.log("---------"+ item.id+","+item.name+","+item.pageSort)
				  // });
				  that.$forceUpdate();
				  //console.log(that.commonAppList)
				  that.setUserApplicationsSortWeb()
			  },			 
		  });
		
		  for (var j = 0; j < that.commonAppList.length; j++) {
		    if (that.commonAppList[j].id) {
				if(that.commonAppList[j].apiUrl!=null && that.commonAppList[j].apiUrl!=''){
					if (that.commonAppList[j].supportDeviceTypes.indexOf("PC") > -1 || (that.commonAppList[j].supportDeviceTypes.indexOf("WEB") > -1 && that.commonAppList[j].description && that.commonAppList[j].description.indexOf('authorization_code')>-1) ) {
					  that.commonAppList[j].appId=that.commonAppList[j].id;
					  that.commonAppList[j].appName=that.commonAppList[j].name;
					  that.commonAppList[j].appLogo=that.commonAppList[j].logoUrl;
					  that.commonAppList[j].appUrl=that.commonAppList[j].url;
					  that.commonAppList[j].totalCount=0;
					  that.commonAppList[j].waitDoMsg=[];											  
					  waitNew.push(that.commonAppList[j]);
					}
				}
		     
		    }
		  }
		  
		  that.waitDoList = waitNew;

          this.getWaitDoMsgByUserId();
		
		  
		 
          // that.setCommonApps();
        } else if (res.data.error.code == 1) {
          // this.$store.commit("/app/logout", this);
          // util.abp.auth.clearToken();
          // if (
          //   window.location.hostname.toLocaleLowerCase().indexOf("gistest") > -1
          // ) {
          //   window.location.href =
          //     "https://gistest.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgistest.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt13%3FenterpriseId%3Dyf";
          // } else {
          //   if (window.location.port == "9185") {
          //     window.location.href =
          //       "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt70%3FenterpriseId%3Dyf";
          //   } else {
          //     window.location.href =
          //       "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf";
          //   }
          // }
		  
		  
		  
          // window.location.href = appconst.gisLogout;
          // 		debugger;
          // 		var times =  localStorage.getItem("idpRetryTimes") ;

          // 		if (times && times > 2) {
          // 			this.$Message.error("token异常,请联系管理员");
          // 			return;
          // 		}
          // 		if (!times) {
          // 			times = 1;
          // 		}
          // 		times = times + 1;
          // 		localStorage.setItem("idpRetryTimes", times);
        }
      });
  },
  
  setUserApplicationsSortWeb(){
	var that = this;
	var newlist=[];
	
	that.newCommonAppList.forEach((item) => {
	 newlist.push({
		 id:item.id,
		 code:item.applicationId,
		 sort:item.pageSort
	 })
	});
	
	this.$store.dispatch({
	    type: "app/setUserApplicationsSortWeb",
	    data: newlist,
	  })
	  .then((res) => {
	   
	  });  
  },

  setCommonApps() {
    var that = this;
    //localStorage.setItem('companyid', session.companyid);
    const local_data_str = localStorage.getItem("local_data");
    var local_data =
      local_data_str != null ? JSON.parse(local_data_str) : [];
    var tmpList = [];
    if (local_data.length > 0) {
      for (var j = 0; j < local_data.length; j++) {
        var exists = false;
        var eachlocal = local_data[j] ;
        for (var i = 0; i < that.mineAppList.length; i++) {
          var eachmine = that.mineAppList[i] ;
          if (eachmine.applicationId == eachlocal.applicationId) {
            eachlocal.startUrl = eachmine.startUrl;
            eachlocal.logoUrl = eachmine.logoUrl.replace("http:", "https:");
            exists = true;
            break;
          }
        }
        if (exists) {
          tmpList.push(eachlocal);
        }
      }
      // that.initStorageData();
    } else {
      //第一次获取我的应用
      // that.initStorageData();
      // uni.setStorage({
      // 	key: 'local_data',
      // 	data: that.mineAppList,
      // 	success: function(e) {
      // 		that.mineAppList = uni.getStorageSync('local_data');
      // 		// console.log(e);
      // 	}
      // });
      tmpList = that.mineAppList;
    }
    localStorage.setItem("local_data", JSON.stringify(tmpList));
    that.commonAppList = tmpList;
    // that.setCommonTag(tmpList);
  },
  getWaitNewsApplication() {
    var that = this;
    var request = {
      SkipCount: 0,
      MaxResultCount: 1000,
      UnRead: false,
    };

    this.$store
      .dispatch({
        type: "app/getWaitNewsApplication",
        data: request,
      })
      .then((res) => {
        that.appList = res.items;
        if (that.appList.length > 0) {
          that.wid = that.appList[0].id;
          that.getWaitDoNewsByUserID();
        }
      });
  },
  getWaitDoNewsByUserID() {
    var that = this;
    var request = {
      SkipCount: 0,
      MaxResultCount: 20,
      AppId: that.wid,
    };
    this.$store
      .dispatch({
        type: "app/getWaitDoNewsByUserID",
        data: request,
      })
      .then((res) => {
        // console.log(res.items);
        that.waitNewsList = res.items;
        for (var i = 0; i < that.waitNewsList.length; i++) {
          that.waitNewsList[i].datetime = Util.formatDate(new Date(), "hh:mm");
          that.waitNewsList[i].creationTime = Util.formatDate(
            new Date(that.waitNewsList[i].creationTime),
            "yyyy-MM-dd hh:mm:ss"
          );
        }
      });
  },
  showNewsDetail(newid) {
    window.open("#/newsdetail?newid=" + newid);
    // this.$router.push({
    // 	path: '/newsdetail',
    // 	query: {
    // 		newid: newid
    // 	}
    // })
  },
  showIscDetail(incidentNumber){
    window.open("#/iscdetail?incidentNumber=" + incidentNumber);
  },
  showAnswerDetail(aid) {
    window.open("#/answerDetail?aid=" + aid);
    // this.$router.push({
    // 	path: '/newsdetail',
    // 	query: {
    // 		newid: newid
    // 	}
    // })
  },
  showDocDetail(row){
	  if(row.type=="Links"){
		   window.open(row.url);
	  }
	  else{
		   window.open("#/directories?did=" + row.id);
	  }
  },
  showNewsList() {
    window.open("#/newsList");
  },
  showNoticeList() {
    window.open("#/noticeList");
  },
  showDirectories() {
    window.open("#/directories");
  },
  showAnswerList() {
    window.open("#/answerList?tid=" + this.activeTag);
  },
  changeApp(index) {
    var that = this;
    that.waitList = new Array();
    var eachinfo = that.waitDoList[index];
    if (eachinfo != undefined) {
      that.wid = eachinfo.appId;
      for (var j = 0; j < eachinfo.waitDoMsg.length; j++) {
        var each = eachinfo.waitDoMsg[j];
        each.name = eachinfo.appName;
        each.logo = eachinfo.appLogo;
        // each.datetime = that.formatDate(new Date(), "hh:mm");
        each.time = Util.formatDate(new Date(each.time), "yyyy-MM-dd hh:mm:ss");
        that.waitList.push(each);
      }
    }

    //that.scrollView=eachinfo.appName;
  },
  getLoginUser() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getLoginUser",
        data: {},
      })
      .then((res) => {
        // console.log("loginuser");
        console.log(res);
        that.userInfo = res;
        that.isCanBook = res.isExternal;
        var phonenumber = res.phoneNumber;
        that.getLoginUserDomainAccount(phonenumber);

        (that.userInfo ).namedd = (that.userInfo ).name;
        (that.userInfo ).postdd = (that.userInfo ).chPost;
        if (abp.localization.currentLanguage.name == "en") {
          (that.userInfo ).namedd = (that.userInfo ).eName;
          (that.userInfo ).postdd = (that.userInfo ).enPost;
        }

        localStorage.setItem("userInfo", JSON.stringify(res));
        //that.getUser(that.userInfo.id);
        if ((that.userInfo ).rootOrganization != null) {
          that.org = (that.userInfo ).rootOrganization;


          (that.org ).namedd = (that.org ).displayName;
          if (abp.localization.currentLanguage.name == "en") {
            (that.org ).namedd = (that.org ).enName;
          }
        }
        if (
          (that.userInfo ).organizations != null &&
          ((that.userInfo ).organizations ).length > 0
        ) {
          for (
            var i = 0;
            i < ((that.userInfo ).organizations ).length;
            i++
          ) {
            if (
              (that.userInfo ).organizations[i].parentId != null &&
              (that.userInfo ).organizations[i].parentId > 0
            ) {
              that.department = (that.userInfo ).organizations[i];

              (that.department ).namedd = (
                that.department 
              ).displayName;
              if (abp.localization.currentLanguage.name == "en") {
                (that.department ).namedd = (
                  that.department 
                ).enName;
              }
            } else {
              that.org = (that.userInfo ).organizations[i];

              (that.org ).namedd = (that.org ).displayName;
              if (abp.localization.currentLanguage.name == "en") {
                (that.org ).namedd = (that.org ).enName;
              }
            }
          }
        }

        that.treeId = (that.department ).id;
        that.getUserByOrgId(that.treeId);

        if ((that.userInfo ).post == null) {
          (that.userInfo ).post = "";
        }
      });
  },
  getLoginUserDomainAccount(phonenumber) {
    var that = this;
    this.$store
      .dispatch({
        type: "user/getUserByUserName",
        data: {
          name: phonenumber,
        },
      })
      .then((res2) => {
        that.domainAccount = res2.domainAccount;
        console.log("domainAccount:" + that.domainAccount);
      });
  },

  // getUser(id) {
  //   var that = this;
  //   this.$store
  //     .dispatch({
  //       type: "app/getUser",
  //       id: id,
  //     })
  //     .then((res) => {
  //       // console.log("getuser");
  //       // console.log(res);
  //       // that.user=res;
  //       // for (var i = 0; i < that.user.organizations.length; i++) {
  //       // 	if (that.user.organizations[i].parentId != null && that.user.organizations[i].parentId > 0) {
  //       // 		that.department = that.user.organizations[i];
  //       // 	} else {
  //       // 		that.org = that.user.organizations[i];
  //       // 	}
  //       // }
  //     });
  // }
  getIDSToken() {
    var that = this;
    this.$store
      .dispatch({
        type: "app/getIDSToken",
        data: {},
      })
      .then((res) => {
        localStorage.setItem("idptoken", res);
      });
  },
  async getAnsterTagList() {
    var that = this;
    var request = new Object() ;
    request.maxResultCount = 1000;
    request.skipCount = 0;
    request.type = 7;

    this.$store
      .dispatch({
        type: "tag/getAllList",
        data: request,
      })
      .then((res) => {
        console.log(res);
        var result = res.items;
        var k = 0;
        for (var i = 0; i < result.length; i++) {
          if (result[i].key != null && result[i].key.trim() == "HotQuestions") {
            that.activeTag = result[i].id;
            k = i;
          }
        }
        if (that.activeTag > 0) {
          result.splice(k, 1);
          that.getAnswerList();
        }
      });
  },
  getAnswerList() {
    var that = this;
    var request = new Object() ;
    request.maxResultCount = 10;
    request.skipCount = 0;
    request.status = 3;
    request.tagId = that.activeTag;
    request.IsAppUser = true;

    var languageName = "";
    console.log(that.lanEn);
    if (abp.localization.currentLanguage.name != "en") {
      languageName = "zh-Hans";
      that.lanEn = false;
    } else {
      languageName = "en";
      that.lanEn = true;
    }
    request.Lang = languageName;
    this.$store
      .dispatch({
        type: "tag/getAnswerAllList",
        data: request,
      })
      .then((res) => {
        //console.log(res);
        var result = res.items;
        var answerList = [];
        for (var i = 0; i < result.length; i++) {
          answerList.push(result[i]);
        }
        that.answerList = answerList;

        const newanswerList = that.newsTO3Col();
        //console.log(" this.answerList====>", newanswerList);
      });
  },
  getQueryVariable(p) {
    var query = window.location.search.substring(1);
    if (query == "") {
      var hashs = window.location.hash.split("?");
      if (hashs.length > 1) {
        query = hashs[1];
      }
      if (query.indexOf("#") > -1) {
        query = query.split("#")[0];
      }
    }
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == p) {
        return pair[1];
      }
    }
    return false;
  },


  
  dataToTree(data, pid = null) {
    if (!Array.isArray(data) || !data.length) return [];
    let newOrgs = [];
    data.forEach((item) => {
      item.label =
        abp.localization.currentLanguage.name != "en"
          ? item.displayName
          : item.enName;
      if (item.parentId == pid) {
        let childrenData = this.dataToTree(data, item.id);
        if (childrenData.length > 0) {
          newOrgs.push({
            ...item,
            children: childrenData,
          });
        } else {
          newOrgs.push({
            ...item,
          });
        }
      }
    });
    return newOrgs;
  },

  getOrgDate(data) {
    let productTypeList = data; // 这个就是后台拿到的数据data
    // 删除所有 children,以防止多次调用(这一步是最后执行完之后加上的,因为不删除会多次调用)
    productTypeList.forEach((el) => {
      delete el.children;
    });

    let map = {};
    productTypeList.forEach((el) => {
      map[el.id] = el; // 循环data拿到所有的id
    });

    let arr = [];
    productTypeList.forEach((el) => {
      let parent = map[el.parentId]; // 拿到所有的pid,如果为真,和id进行对比,如果pid===id,就说明是id的子集

      if (parent) {
        (parent.children || (parent.children = [])).push(el);
      } else {
        // 如果不是就是第一级,没有pid或者pid为0
        arr.push(el);
        // console.log('arr', arr)
      }
    });
    return arr;
  },

  setAllOrg(obj) {
    var that = this;
    var newData = [];
    for (let i = 0; i < that.orgAllList.length; i++) {
      var each = that.orgAllList[i] ;
      newData.push({
        id: each.id,
        parentId: each.parentId,
        title: each.displayName,
        checked: false,
        label:
          abp.localization.currentLanguage.name != "en"
            ? each.displayName
            : each.enName,
      });
    }
    that.orgDate = that.getOrgDate(newData);
  },

  getBookList() {
    var that = this;
    that.$store
      .dispatch({
        type: "user/getOrganizationList",
        data: {
          SkipCount: 0,
          MaxResultCount: 1000,
          Keyword: "",
          ParentId: 0,
          Top: false,
          IsAppUser: false,
        },
      })
      .then((res) => {
        if (res.success) {
          var orgList = res.result.items;
          that.orgAllList = orgList;
          that.setAllOrg("");

          let topList = [];
          orgList.forEach((item) => {
            if (!item.parentId) {
              topList.push(item);
            }
          });

          this.treeData = this.dataToTree(orgList);
          // that.orgList = newOrgs;
          // that.orgs = newOrgs;
          // that.orgs = that.getOrgTreeData();
        }
      });
  },
  // 部门联系人
  async getUser() {
    let params = {
      maxResultCount: 10000,
      skipCount: 0,
      hasOrgTop: this.txlInputValue ? false : true,
      source: this.isShowWB ? "GAC" : "",
      keyWord: this.txlInputValue,
    };
    await this.$store.dispatch({
      type: "user/getAll",
      data: params,
    });
    let newDataList = JSON.parse(JSON.stringify(this.$store.state.user.list));
    let dataList = newDataList.map((item) => {
      return {
        ...item,
        isShowInfo: false,
      };
    });
    this.txlUserList = dataList;
    this.fliterTxlUser = dataList;
  },

  // 根据部门id查询联系人
  async getUserByOrgId(id) {
    let params = {
      organizationUnitId: id,
      source: this.isShowWB ? "GAC" : "",
	  nameOrPhone:this.txlInputValue
    };
    await this.$store
      .dispatch({
        type: "user/getOrganizationListById",
        data: params,
      })
      .then((res) => {
        if (res.success) {
          let dataList = res.result.map((item) => {
            return {
              ...item,
              isShowInfo: false,
            };
          });
          this.txlUserList = dataList;
          this.fliterTxlUser = dataList;
        }
      });
  },

  getUserAuth() {
    this.$store
      .dispatch({
        type: "app/getAll",
      })
      .then((res) => {
        console.log(
          "res.auth.grantedPermissions.AppAIUser==========>",
          res.auth.grantedPermissions.AppAIUser
        );
        if (
          res.auth.grantedPermissions &&
          res.auth.grantedPermissions.AppAIUser &&
          res.auth.grantedPermissions.AppAIUser != undefined &&
          res.auth.grantedPermissions.AppAIUser.toLowerCase() == "true"
        ) {
          this.isCanHaoqi = true;
        } else {
          this.isCanHaoqi = false;
        }
      });
  },

  pageLoad() {
	  var that=this;
    this.getIDSToken();
    this.getLoginUser();
    this.getUserAuth();
    //this.getWaitDoMsgByUserId();
    //this.getNewsList();
    //this.getNoticeList();
    this.getApplicationList();
    this.getAnsterTagList();
    this.getBookList();
	// that.intranet=true;
	// that.getAllDirectories();
    //this.getUser();
    // this.getMustReadClassify();
    this.getISCList();
	var histname = window.location.hostname;
	
	if (histname.indexOf("gistest.yfpo.com") != -1) {
		//测试库
		that.intranet=true;
		that.getAllDirectories();
	} 
	else{
		that.request('https://gisapi.yfpo.com/', function(res) {
			// alert(res ? '内网' : '外网')
			console.log(res ? '内网' : '外网');		
			if(res){
				that.intranet=true;
				that.getAllDirectories();
			}
			else{
				that.intranet=false;
			}
			
		})
	}
	
  },
  async request(url, res) {
  	const ajax = axios.create({
  		baseURL: url,
  		timeout: 3000,
  		headers: {
  			'cache-control': 'no-cache',
  			'Pragma': 'no-cache'
  		}
  	});
  	ajax.interceptors.response.use((respon) => {
  		return respon
  	}, (error) => {
  		// alert(JSON.stringify(error))
  		res(false);
  	})
  	let response = await ajax.get('/AbpUserConfiguration/GetAll');
  	if (response && response.status == 200) {
  		res(true);
  	}
  },

  
  replaceHashParameter(paramKey) {
    let route = this.$router.currentRoute;
    if (route.query.hasOwnProperty(paramKey)) {
      delete route.query[paramKey];
      // route.query[paramKey]=""
      //route.query["time"] = new Date().getTime();

      const newQuery = {
        ...route.query,
        time: new Date().getTime(),
      };
      // 使用 `this.$router.push` 来更新 URL 的 query 部分，但不会导航到一个新的路由
      this.$router.push({
        path: this.$route.path,
        query: newQuery,
      });
    }
    // 使用URL对象获取当前URL
    var url = new URL(window.location.href);
    if (url.searchParams.has(paramKey)) {
      // 删除指定的查询参数
      url.searchParams.delete(paramKey);
      // 用新的URL替换当前页面的地址
      window.history.pushState({}, "", url.toString());
    }
  },

  formatStringToDate(dateString, fmt) {
    dateString = dateString.substr(0, 19);
    dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");
    var date = new Date(dateString);
    return this.formatDate(date, fmt);
  },
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    // // #ifdef APP-PLUS
    // date.setHours(date.getHours()-8);
    // // #endif
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  },
  padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  }
}
</script>
<style>
html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

#webpack-dev-server-client-overlay {
  display: none;
}
/* 定义动画 */
@keyframes slideInFromRight {
  0% {
    transform: translateX(100%); /* 从屏幕右侧开始 */
    /* opacity: 0; */
	 width: 0%; 
  }
  100% {
    transform: translateX(0); /* 移动到屏幕左侧（即无位移） */
    /* opacity: 1; */
	 width: 25%; 
  }
}
 
/* 应用动画 */
.slide-in-right {
  animation: slideInFromRight 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，保持最终状态 */
}
.deputy-post-title {
		padding: 14px 0 10px 10px;
		position: relative;
		color: #666;
		cursor: pointer;
	}
	.deputy-post-title img {
	  /* transform: scaleY(-1); */
	  width: 12px;
	  height: 12px;
	}

	.deputy-post-item {
		font-size:14px;
		padding:6px;
		box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		margin-bottom: 10px;

	}
	.empty-text {
		text-align: center;
		color: #999;
		padding: 40px 20px;
		font-size: 14px;
	}
	

.home-left{
	position: relative;
}
@keyframes shrinkWidth {
	0% {
	    /* left: 100%;  初始位置在父容器的右边外 */
	    width: 80%; /* 宽度为100% */
	  }
	  100% {
	    /* left: 0;  移动到父容器的左边  */
	    width: calc(55% - 20px); /* 宽度变为0 */
	  }
  /* from {
	
    width: 80%; 
  }
  to {
	
    width: calc(55% - 20px); 
  } */
}
 
.element {
 
  animation: shrinkWidth 1s ease-out forwards; /* 应用动画，持续3秒，保持结束状态 */
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.zspan {
  color: red;
  font-size: 30px;
  position: absolute;
  left: 100px;
  top: -6px;
}

.espan {
  color: red;
  font-size: 30px;
  position: absolute;
  left: 145px;
  top: -6px;
}

.homePage {
  position: relative;
  font-size: 14px;
  width: 100%;
  /* width: calc(100% + 20px); */
  /* height: calc(100% + 20px); */
  /* margin-left: -10px; */
  /* margin-top: -10px; */
  margin-top: -5px;
  background: #f3f4f6;
}

/* 
.Haoqi {
  position: absolute;
  right: 0;
  top: 30%;
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
}
.Haoqi:hover {
  color: #fff;
  background-color: #37b5e7;
}

.Haoqi img {
  width: 35px;
  height: 35px;
  display: block;
  margin: 4px auto;
}
.Haoqi div {
  width: 100%;
  text-align: center;
  color: #666;
  font-size: 12px;
}

.Tool {
  position: absolute;
  right: 80px;
  bottom: 10px;
  width: 50px;
  height: 100px;
}

.Tool div {
  width: 40px;
  height: 40px;
  margin: 10px auto;
  background: #fff;
  cursor: pointer;
  border-radius: 20px;
}

.Tool div img {
  width: 20px;
  height: 20px;
  margin: 10px;
} */

.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
  vertical-align: top;
}

.upload-list img {
  width: 100%;
  height: 100%;
}

.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.upload-list:hover .upload-list-cover {
  display: block;
}

.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.home-contant {
  /* width: calc(100% - 300px); */
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  /* margin: 0 150px; */
}

.home-left1 {
  /* width: 340px; */
  width: 20%;
  /* margin-left: 10px; */
  height: 100%;
  float: left;
  background: #f3f4f6;
  /* border-right: 1px solid #e3e4e6; */
}

.home-left1-top {
  /* width: 330px; */
  margin: 0 auto 10px;
  /* height: 205px; */
  height: 100%;
}

.home-left1-bottom {
  /* width: 330px; */
  height: 100%;
  /* height: calc(100% - 215px); */
  margin: auto;
  position: relative;
}

.home-left1-bottom-txl {
  width: 100%;
}

.txlH1 {
  height: calc(100% - 270px);
}

.txlH2 {
  height: 90%;
}

.txl-top-serch-contant {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tree-data-contant {
  margin: 5px 0;
  flex:1;
  min-width:130px;
}

.vue-treeselect__menu {
  width: 300px;
}

.txl-top-serch-search {
  /* width: 30px;
  margin: 10px;
  text-align: center;
   border: 1px solid; */
  /*font-size: 20px; */

  width: 20px;
  margin: 0 30px 0 10px;
  text-align: center;
  /* border: 1px solid; */
  font-size: 20px;
}

.txl-top-serch-check {
  /* flex: 1;
  text-align: right; */
  /* line-height: 40px; */
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-left: 5%;
}

.txl-user-contant {
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: auto;
}

.txl-user-item {
  width: 100%;
  height: 50px;
  overflow: hidden;
  /* border-bottom: 1px solid #e3e4e6; */
  display: flex;
  background: #f7f9fa;
  margin: 2px 0;
  padding: 2px 0;
}

.txl-user-img {
  width: 25px;
  height: 25px;
  margin: 10px;
}

.txl-user-img-down {
  width: 12px;
  height: 12px;
  margin: 18px;
}

.txl-user-name {
  flex: 1;
  overflow: hidden;
}

.txl-user-name p {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.txl-user-item-info {
  width: 100%;
  min-height: 150px;
  background: #f7f9ff;
  padding: 0 10px;
}

.txl-user-item-info-label {
  color: #666;
  width: 100px;
  text-align: left;
  padding-left: 10px;
  display: inline-block;
  float: left;
}

.w135 {
  width: 135px;
}

.txl-user-item-info-span {
  width: calc(100% - 135px);
  display: inline-block;
}

.ivu-tabs-bar {
  margin-bottom: 6px;
}

.ivu-tabs-tab {
  min-width: 70px;
  text-align: center;
  padding: 5px !important;
}

.home-left1-bottom-qrcode {
  /* width: 100%;
  height: 300px; */
  position: absolute;
  bottom: 0;
  left: 10px;
  width: calc(100% - 20px);
  /* height: 230px;
  margin: 0 10px; */
}

.home-left1-bottom-qrcode-show {
  /* position: absolute;
  bottom: 0;
  left: 0;
  width: 325px;*/ 
      height: 20px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 10px;
}

.home-left1-bottom-qrcode-show img {
  transform: scaleY(-1);
  width: 20px;
  height: 15px;
}

.home-left {
  /* width: 55.4%; */
  width: calc(55% - 20px);
  height: 100%;
  /* float: left; */
  margin: 0 10px;
}
.demo-split-pane {
	height: 100%;
}

.home-left-top {
  width: 100%;
  height: 100%;
  /* height: calc(40% - 10px); */
  /* height:  330px; ; */
}

.home-left-ceneter {
  width: 100%;
  height: 100%;
  /* height: 35%; */
  /* margin: 10px 0; */
}

.home-left-ceneter-left {
  width: calc(50% - 5px);
  height: 100%;
  float: left;
}

.home-left-ceneter-right {
  width: calc(50% - 5px);
  height: 100%;
  float: right;
}

.home-left-bottom {
  width: 100%;
  height: 100%;
  /* height: 25%; */
  /* height: calc(65% - 310px); */
  /* margin-top: 10px; */
}

.home-left-bottom-left,
.home-left-bottom-right {
  width: calc(50% - 5px);
  height: 100%;
  float: left;
}

.home-left-bottom-right {
  float: right;
}

.home-right {
  /* width: calc(44% - 350px); */
  /* flex: 1; */
  width: 25%;
  min-width: 0px;
  height: 100%;
  /* float: right; */
  padding: 10px 2px 0;
  padding-top: 0;
}

.home-right-top {
  width: 100%;
  height: 73%;
  margin-bottom: 10px;
}

.haoqi-contant {
  width: 100%;
  height: calc(100% - 40px);
}

.home-right-bottom {
  width: 100%;
  height: 28%;
  padding-bottom: 10px;
}

.area-item {
  border: 1px solid #ccc;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
}
.flex{
	display: flex;
}
.area-item-left-box{
	display: flex;
	align-items: center;
	grid-gap: 10px;
}

.area-item-title {
  width: 100%;
  height: 35px;
  line-height: 24px;
  position: relative;
}

.area-item-title-text {
  font-weight: 600;
  font-size: 16px;
  float: left;
  color: #000;
}
.area-item-title-text-tips{
	margin-left: 10px;
	    float: left;
	    color: #999;
	    font-size: 13px;
}

.area-item-title-input {
  float: right;
  width: 210px;
  height: 30px;
}

.more {
  color: #37b5e7;
  float: right;
  cursor: pointer;
}

.more-IT {
  color: #ff1b1b;
  text-decoration: underline;
  cursor: pointer;
}

.tag-contant {
  float: left;
  margin-left: 20px;
}

.tag-item,
.tag-item-active {
  float: left;
  padding: 0px 10px;
  border: 1px solid #ccc;
  /* border-radius: 10px; */
  margin: 0 4px;
  cursor: pointer;
}

.tag-item-active {
  /* color: #ffff; */
  color: #37b5e7;
  /* background: #37b5e7; */
  border: 1px solid #37b5e7;
}

.app-contant {
  width: 100%;
  max-height: calc(100% - 30px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.app-contant .ivu-tabs {
  overflow: unset;
}

.app-contant .app-contant-tab-pane {
  flex: 1;
  min-height: 0px;
  overflow-y: auto;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
}

.app-item {
  width: calc(20% - 10px);
  height: 70px;
  margin: 5px;
  padding: 5px;
  background: #f7f9fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1); */
}
.app-item .ivu-tooltip-rel{
	width: 100%;
}

.app-item:hover {
  /* box-shadow: 0 0 4px 2px rgba(55, 181, 231, 0.1); */
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
}

.app-item-img {
  float: left;
  width: 50px;
  height: 50px;
  margin: 5px 0 0 5px;
}

.app-item-title {
  //line-height: 60px;
  float: left;
  width: 100%;
  padding-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
}

.mine-contant {
  width: 100%;
  height: calc(100% - 30px);
  line-height: 35px;
  position: relative;
}
.scan-contant-tip{
	width: 20px;
	cursor: pointer;
}

.mine-contant-tip {
  position: absolute;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.mine-contant-tip img {
  float: left;
}

.mine-contant-left {
  width: 60%;
  height: 100%;
  float: left;
}

.mine-contant-right {
  width: 40%;
  height: 100%;
  float: right;
}

.name {
  font-size: 18px;
  font-weight: 600;
  text-align: left;
}

.task-contant {
  width: 100%;
  height: calc(100% - 30px);
  overflow-y: auto;
}

/* .task-contant-hot {
  height: calc(100% - 80px);
  margin-bottom: 10px;
} */

.task-item {
  border-bottom: 1px solid #edf2f8;
  padding-left: 40px;
  position: relative;
  line-height: 35px;
  min-height: 35px;
  height: auto;
  width: 100%;
  cursor: pointer;
  position: relative;
}

.task-item-contant {
  width: 78%;
  float: left;
  height: 100%;
  /* display: inline-block;
  position: relative; */
}

.task-item-contant-title {
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 12px;
  color: #333;
}

.task-item-contant-time {
  /* position: absolute;
  bottom: -20px;
  right: 0; */
  display: block;
  font-size: 12px;
  color: #666;
  line-height: 14px;
  text-align: right;
}

.task-item-img {
  width: 20%;
  display: inline-block;
  float: right;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
}

.task-item-img .newimg {
  height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  border-radius: 5px;
}

.task-db-contant {
  width: 100%;
  height: calc(100% - 30px);
}

.task-db-list {
  width: 170px;
  height: 100%;
  float: left;
  border-right: 1px dotted #ccc;
  overflow-y: auto;
}

.task-db-list-e {
  width: 210px;
}

.task-db-list-menu {
  width: 100% !important;
  height: 100%;
  overflow-y: auto;
  z-index: 0;
}

.task-db-list-contant {
  width: calc(100% - 170px);
  height: 100%;
  float: left;
  padding: 0 10px;
  overflow-y: auto;
}

.task-db-list-contant-e {
  width: calc(100% - 210px);
}

.task-db-item {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.task-db-item-active {
  background-color: rgba(55, 181, 231, 0.2);
}

.task-db-item span {
  display: inline-block;
  margin-left: 10px;
}

.task-db-item span:nth-child(1) {
  line-height: 15px;
  padding: 0 5px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
  font-size: 10px;
  background: red;
  font-style: normal;
  float: left;
  margin: 10px;
}

.task-db-item img {
  width: 30px;
  height: 30px;
  display: inline-block;
}

.task-db-list-item {
  margin-bottom: 5px;
  /* border-bottom: 1px solid #eaeaea; */
  padding: 0 5px;
  background: #f7f9fa;
  position: relative;
}

.task-db-list-item:hover {
  cursor: pointer;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
}

.read-contant {
  width: 100%;
}

.read-status {
  font-size: 12px;
  float: left;
}

.read-status-unread {
  color: #ff0000;
}

.read-status-read {
  color: #339966;
}

.read-time {
  font-size: 12px;
  text-align: right;
  line-height: 12px;
  position: absolute;
  bottom: 2px;
  right: 2px;
}

.read-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  display: inline-block;
  width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
}

.backlogtit {
  padding: 5px;
  position: relative;
  /* border-bottom: 1px solid #a8cee8; */
  float: left;
  width: 50px;
  margin: auto;
}

.backlogtitimg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin: 10px 0;
}

.backlogtit .title {
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  color: #004d81;
  margin-left: 5px;
}

.backlogtit .time {
  font-size: 13px;
  color: #999;
  position: absolute;
  top: 20%;
  right: 0;
}

.backlogcot {
  padding: 10px;
}

.backlogcot text {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  color: #666;
}

.backlogcot text.logcottit {
  font-size: 15px;
  color: #000;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.wrongBox {
  width: 600px;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.w0 {
  width: auto;
}
.title-qrcode{
	font-weight: bold;
	font-size: 1.2rem;
}
.wrongBox .title {
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.wrongBox p {
  line-height: 30px;
}

.wrongBox .close {
  position: absolute;  
  right: 15px;
  width: 20px;
      top: 15px;
}

        #qrcode-container {
            background: white;
            padding: 1rem;
            border-radius: 32px;
            box-shadow: 0 20px 30px -10px rgba(0, 20, 40, 0.3);
            display: inline-block;
            margin: 0.8rem 0;
            border: 1px solid #cdddec;
            position: relative;
        }
		#finalCanvas {
		    display: block;
		    border-radius: 16px;
		    width: 240px;
		    height: 240px;
		}
		.hint-text {
		    color: #1e3a5a;
		    font-weight: 400;
		    margin: 0.5rem 0 1.3rem 0;
		    background: #d3e2fc;
		    padding: 0.4rem 2rem;
		    border-radius: 60px;
		    font-size: 0.95rem;
		    border: 1px solid white;
		}
		.download-area {
		    display: flex;
		    flex-wrap: wrap;
		    align-items: center;
		    justify-content: center;
		    gap: 1.2rem;
		    margin-top: 0.3rem;
		}
		.download-btn {
		    background: white;
		    border: 1px solid #b7cee8;
		    color: #1f3a5f;
		    padding: 0.8rem 2rem;
		    border-radius: 38px;
		    font-size: 1rem;
		    font-weight: 500;
		    display: inline-flex;
		    align-items: center;
		    gap: 0.5rem;
		    cursor: pointer;
		    transition: all 0.15s;
		    box-shadow: 0 4px 8px rgba(0,0,0,0.02);
		    text-decoration: none;
		    background: rgba(255,255,255,0.8);
		}
		.download-btn:hover {
		    background: #ecf3fc;
		    border-color: #1f3a5f;
		    box-shadow: 0 8px 14px -8px #1f3a5f;
		    transform: translateY(-1px);
		}
		.download-btn i {
		    font-size: 1.2rem;
		    font-style: normal;
		}

.drawer {
  position: fixed;
  top: 0;
  right: 0;
  transition: width 0.2s ease-out, opacity 0.2s ease-in, visibility 0.2s ease-in;
  width: 0;
  height: 100vh;
  opacity: 0;
  background-color: white;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

.drawer-active {
  opacity: 1;
  visibility: 1;
  width: 500px;
}

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.waitnum {
  position: absolute;
  left: 10px;
  top: 7px;
  display: block;
  line-height: 15px;
  width: 15px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
  font-size: 10px;
  background: red;
  font-style: normal;
}

.leftbox {
  width: 250px;
  margin-right: 10px;
  height: 100%;
  display: inline-block;
  float: left;
}

.rightbox2 {
  width: 250px;
  margin-left: 10px;
  height: 100%;
  display: inline-block;
  float: right;
}

.rightbox {
  width: calc(100% - 520px);
  height: 100%;
  display: inline-block;
  float: right;
}

.task {
  border-radius: 10px;
  background: #fff;
  margin-bottom: 6%;
  background: #fff;
  height: 64%;
  position: relative;
}

.appQrcode {
  border-radius: 10px;
  background: #fff;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  /* width: 300px; */
  width: 70%;
  margin: auto;
  position: relative;
}

.close {
  width: 16px;
  position: absolute;
  right: 10px;
  top: 15px;
}

.appQrcode p {
  text-align: center;
  line-height: 30px;
  color: #666;
}

.appQrcode .qrcode {
  /* width: 150px; */
  margin: 0 auto;
}

.task:last-child {
  margin: 0;
}

.taskcot {
  height: calc(100% - 40px);
  overflow-y: scroll;
  border: 1px solid #000000;
  border-top: 0;
}

.tasktitle {
  background: #cadaf1;
  color: #000;
  height: 30px;
  line-height: 24px;
  padding: 5px 10px;
  position: relative;
}

.wrong {
  font-size: 12px;
  float: right;
}

.taskicons {
  height: 33%;
  margin-bottom: 10px;
}

.taskicons .taskIconcot {
  border: 1px solid #000000;
  border-top: 0;
  height: calc(100% - 30px);
  overflow-y: scroll;
}

.appsitem {
  width: 100px;
  float: left;
  text-align: center;
  margin-bottom: 5px;
  height: 160rpx;
  position: relative;
}

.appsitem .num {
  position: absolute;
  top: 5px;
  right: 5px;
  display: block;
  line-height: 15px;
  width: 15px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
  font-size: 10px;
  background: red;
  font-style: normal;
}

.appsitem .edit {
  position: absolute;
  top: 5px;
  right: 5px;
  display: block;
  height: 20px;
  line-height: 17px;
  width: 20px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  font-size: 15px;
  font-style: normal;
  font-weight: bold;
}

.appsitem .appsitemimg {
  width: 100%;
  height: 50px;
  display: block;
}

.appsitem .appsitemimg img {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0 auto;
}

.appsitem .appsitemimg img.appsitemimgbox {
  margin: 15px auto;
}

.appsitem .apptit {
  text-align: center;
  /* width:200px; */
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.taskitem {
  border-bottom: 1px solid #edf2f8;
  padding-left: 40px;
  position: relative;
  line-height: 30px;
}

.taskitem img {
  width: 30px;
  height: 30px;
  display: block;
  position: absolute;
  top: 0;
  left: 5px;
}

.taskitem img.img20 {
  width: 20px;
  height: 20px;
  top: 5px;
}

.tasklist {
  height: 33%;
}

.tasklistcot {
  border: 1px solid #000000;
  border-top: 0;
  padding: 10px;
  height: calc(100% - 40px);
  overflow-y: scroll;
}

.tasktitle .more {
  color: #999;
  line-height: 30px;
  position: absolute;
  top: 0;
  right: 10px;
  cursor: pointer;
}

/* .daibanList {
		height: calc(100% - 40px);
		overflow-y: scroll;
	} */

.listTop {
  height: 40px;
}

.listTop .inputleft {
  width: 50%;
  float: left;
}

.listTop .pageright {
  float: right;
}

/* 待办列表 */
.backlogitem {
  margin-bottom: 10px;
  padding: 0 10px;
  background: #fff;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  width: 49%;
  float: left;
  margin-right: 10px;
}

.logcotlook {
  font-size: 12px;
  color: #666;
  padding: 5px 10px;
}

.fiximg {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 5px;
  right: 30px;
  z-index: 1;
  opacity: 0.2;
}

.noticewrap {
  height: 33%;
}

.noticeleft {
  width: 49.9%;
  height: 100%;
  float: left;
}

.newsright {
  width: 49.9%;
  height: 100%;
  float: right;
}

.minemeg {
  border-radius: 10px;
  margin-bottom: 6%;
  background: #fff;
  height: 35%;
}

.minecot {
  border: 1px solid #000000;
  border-top: 0;
  padding: 10px;
  height: calc(100% - 40px);
}

.minecot div {
  font-size: 14px;
  /* margin-bottom: 5px; */
}

.minecot .avanter img {
  display: block;
  width: 60px;
  height: 60px;
  margin: 10px 0;
}

.minecot .name {
  font-weight: bold;
  margin-bottom: 5px;
}

/* 新闻列表 */

.newsitem {
  height: 54px;
  border-bottom: 1px solid #eaeaea;
  padding: 5px 10px;
  width: 50%;
  float: left;
  border-right: 1px solid #ddd;
  box-sizing: border-box;
  cursor: pointer;
}

.newscot {
  width: 78%;
  display: inline-block;
  float: left;
  position: relative;
  height: 100%;
}

.newscot .newstit {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 12px;
  color: #333;
}

.newscot .newstime {
  position: absolute;
  bottom: -4px;
  right: 0;
  font-size: 12px;
  color: #666;
}

.newsimg {
  width: 20%;
  height: 100%;
  display: inline-block;
  float: right;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
}

.newsimg .newimg {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
}
</style>

<style lang="less">
.eventItemWrap {
  overflow-y: scroll;
  padding-right: 4px;
  cursor: pointer;

  &:hover {
    -webkit-box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
  }

  .eventItem {
    width: 100%;
    margin-bottom: 8px;
    background-color: #f7f9fa;
    box-sizing: border-box;
    padding: 10px 10px;


    .eventNoWrap {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px dashed #b1b1b1;
      padding: 0 0 5px 0;

      .eventNo {
        color: #222;
      }

      .eventStatus {
        color: #222;
      }
    }

    .ownerWrap,
    .symptomWrap {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;

      .symptom {
        width: 100%;
        color: #222;
        font-size: 13px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }


      .urgency {
        color: #222;
        font-size: 13px;
      }


      .owner {
        color: #222;
        font-size: 13px;
      }
    }

    .subjectWrap {
      margin-top: 5px;


      .subject {

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;

      }

    }

    .timeWrap {
      margin-top: 5px;
      text-align: right;

      .time {
        color: #aaa;
        font-size: 13px;
      }
    }
  }
}
</style>
